// PostHog tracking events for the Aleta application

export const trackNavigation = (posthog, params, colla) => {
    if (!posthog) return;

    if (params.length === 0) {
        posthog.capture('navigation', { section: 'proves', path: window.location.pathname });
        return;
    }

    const isInPissarra = params.length >= 3;
    const isInPissarraReadOnly = isInPissarra && params[3] !== 'edit';
    const isInProjector = params.length > 0 && ['esdeveniments', 'assaigs', 'activitats', 'actuacions'].includes(params[0]);
    const isInGestio = params.length > 0 && params[0] === 'gestio';
    const isInCalendar = params.length > 0 && params[0] === 'calendar';
    const isInNotifications = params.length > 0 && params[0] === 'notifications';
    const isInFeedback = params.length > 0 && params[0] === 'feedback';
    const isInEditor = params.length > 0 && params[0] === 'editor';
    const isInForms = params.length > 0 && params[0] === 'forms';
    const isInFormsPublic = params.length > 0 && params[0] === 'forms' && params[params.length - 1] === 'respostes';
    const isFillingForm = params.length > 0 && params[0] === 'f';
    const isInStats = params.length > 0 && params[0] === 'stats';
    const isInEtiquetes = params.length > 0 && params[0] === 'etiquetes';
    const isInFitxar = params.length > 0 && params[0] === 'fitxar';
    const isInEnllaços = params.length > 0 && params[0] === 'links';
    const isInMerxandatge = params.length > 0 && params[0] === 'botiga';
    const isInQuotes = params.length > 0 && params[0] === 'quotes';
    const isInMapaAccions = params.length > 0 && params[0] === 'mapa';
    const isInRols = params.length > 0 && params[0] === 'rols';

    if (isInPissarra) {
        posthog.capture('navigation', { 
            section: 'pissarra', 
            path: window.location.pathname,
            readonly: isInPissarraReadOnly,
            event_id: params[1]
        });
    } else if (isInProjector) {
        posthog.capture('navigation', { 
            section: 'projector', 
            path: window.location.pathname,
            event_type: params[0]
        });
    } else if (isInGestio) {
        posthog.capture('navigation', { section: 'gestio', path: window.location.pathname });
    } else if (isInCalendar) {
        posthog.capture('navigation', { section: 'calendar', path: window.location.pathname });
    } else if (isInNotifications) {
        posthog.capture('navigation', { section: 'notifications', path: window.location.pathname });
    } else if (isInFeedback) {
        posthog.capture('navigation', { section: 'feedback', path: window.location.pathname });
    } else if (isInEditor) {
        posthog.capture('navigation', { section: 'editor', path: window.location.pathname });
    } else if (isInForms) {
        posthog.capture('navigation', { 
            section: 'forms', 
            path: window.location.pathname,
            is_public: isInFormsPublic
        });
    } else if (isFillingForm) {
        posthog.capture('navigation', { 
            section: 'fill_form', 
            path: window.location.pathname,
            form_id: params[1]
        });
    } else if (isInStats) {
        posthog.capture('navigation', { section: 'stats', path: window.location.pathname });
    } else if (isInEtiquetes) {
        posthog.capture('navigation', { section: 'etiquetes', path: window.location.pathname });
    } else if (isInFitxar) {
        posthog.capture('navigation', { section: 'fitxar', path: window.location.pathname });
    } else if (isInEnllaços) {
        posthog.capture('navigation', { section: 'enllacos', path: window.location.pathname });
    } else if (isInMerxandatge) {
        posthog.capture('navigation', { section: 'merxandatge', path: window.location.pathname });
    } else if (isInQuotes) {
        posthog.capture('navigation', { section: 'quotes', path: window.location.pathname });
    } else if (isInMapaAccions) {
        posthog.capture('navigation', { section: 'mapa_accions', path: window.location.pathname });
    } else if (isInRols) {
        posthog.capture('navigation', { section: 'rols', path: window.location.pathname });
    }
};

export const trackAppInitialized = (posthog, colla, serverEndpoint) => {
    if (!posthog) return;
    
    posthog.capture('app_initialized', { 
        colla,
        server_endpoint: serverEndpoint,
        path: window.location.pathname
    });
};

export const trackCastellersInfoLoaded = (posthog, colla) => {
    if (!posthog) return;
    
    posthog.capture('castellers_info_loaded', { 
        colla
    });
};

export const trackCastellersInfoLoadError = (posthog, colla, error) => {
    if (!posthog) return;
    
    posthog.capture('castellers_info_load_error', { 
        colla,
        error: error?.message || 'Unknown error'
    });
};

export const trackUserLoginSuccess = (posthog, colla) => {
    if (!posthog) return;
    
    posthog.capture('user_login_success', { 
        colla
    });
};

export const trackSocketUserAssociated = (posthog, colla, serverEndpoint) => {
    if (!posthog) return;
    
    posthog.capture('socket_user_associated', { 
        colla,
        server_endpoint: serverEndpoint
    });
};

export const trackReactErrorBoundary = (posthog, colla, error, errorInfo, errorId) => {
    if (!posthog) return;

    posthog.capture('react_error_boundary', {
        colla,
        error_id: errorId,
        error_name: error?.name,
        error_message: error?.message,
        component_stack: errorInfo?.componentStack,
        url: window.location?.href
    });
};